export const ADD_MINUTES_TIME = 30;
